import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider as UrqlProvider } from 'urql'
import { gqlClient } from './lib/gql.js'
import App from './App.js'
import { initTheme } from './stores/theme.store.js'
import { loadBranding } from './lib/branding-loader.js'
import './styles.css'

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1 } } })

initTheme()
void loadBranding()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <UrqlProvider value={gqlClient}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <App />
        </BrowserRouter>
      </UrqlProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
